import React, { FC } from 'react'

import { IconStateSuccessInverseProps } from './IconStateSuccessInverse.types'
import * as Styled from './styles/IconStateSuccessInverse.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStateSuccessInverse: FC<IconStateSuccessInverseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStateSuccessInverseProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconStateSuccessInverseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M79.848 0c44.099 0 79.848 35.749 79.848 79.848s-35.75 79.848-79.848 79.848C35.749 159.696 0 123.947 0 79.848S35.75 0 79.848 0Zm52.289 41.593a3.629 3.629 0 0 0-5.132.08l-66.482 68.59L32.71 81.114a3.63 3.63 0 0 0-5.251 5.01l30.417 31.878a3.627 3.627 0 0 0 2.611 1.123h.014a3.63 3.63 0 0 0 2.606-1.103l69.109-71.299a3.628 3.628 0 0 0-.08-5.13Z'
          fill='#FFF'
          fillRule='evenodd'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStateSuccessInverse
